import React from 'react';

import { LegacyButton } from '@zapier/design-system';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useQueryZapierSession } from 'app/developer-v3/hooks';

function CreateZapTemplateButton() {
  const { isLoading: isLoadingUser, data } = useQueryZapierSession();
  const currentAccountId = data?.currentAccountId;
  const createZapTemplateUrl = new URL(
    '/webintent/create-template',
    ZAPIER_APP_BASE_URL
  );
  createZapTemplateUrl.search = new URLSearchParams({
    context: String(currentAccountId),
  }).toString();

  return (
    <LegacyButton
      disabled={isLoadingUser}
      href={createZapTemplateUrl.href}
      target="_blank"
    >
      Create Zap Template
    </LegacyButton>
  );
}

export default CreateZapTemplateButton;
